angular.module('gym.mobile_app').directive('mobileAppSettingsEventDefaults', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/mobile_app/event_defaults.html.slim'),
    controller: ["$scope", "MobileApp", "ProximityCheckinLocations", "MessageService", "flash", function($scope, MobileApp, ProximityCheckinLocations, MessageService, flash) {
      MobileApp.all('settings').doGET('meta').then(function(data) {
        return $scope.meta = data.plain();
      });
      MobileApp.all('settings').getList().then(function(data) {
        $scope.settings = data[0];
        return $scope.settings.rootObjectName = 'gym_mobile_app_detail';
      });
      $scope.saveSettings = function() {
        return $scope.settings.save();
      };
      $scope.bulkEnable = function() {
        return MessageService.message({
          title: 'Bulk-enable proximity check-in',
          message: `Please confirm you would like proximity check-in to be <strong>enabled</strong> for all existing events in your calendar.`,
          confirmButtonText: 'Ok'
        }).then(function() {
          return ProximityCheckinLocations.doPUT({}, 'bulk_enable').then(function() {
            return flash.success = 'Enabled successfully';
          });
        });
      };
      return $scope.bulkDisable = function() {
        return MessageService.message({
          title: 'Bulk-enable proximity check-in',
          message: `Please confirm you would like proximity check-in to be <strong>disabled</strong> for all existing events in your calendar.`,
          confirmButtonText: 'Ok'
        }).then(function() {
          return ProximityCheckinLocations.doPUT({}, 'bulk_disable').then(function() {
            return flash.success = 'Disabled successfully';
          });
        });
      };
    }]
  };
});
